<template>
  <div class="form-row__sub">
  <template v-if="!captchaMessage && !checkConfirmPhone" >
<!--    <div class="phone-confirm" :class="{ 'ajax-processed' : ajaxProcessed, }" v-if="(!isPhoneConfirmed && smsSended) || (counter > 0)">-->
        <template v-if="!isPhoneConfirmed && smsSended" >
          <div class="phone-field">
            <label for="UF_PHONECONFIRM_CODE" class=" label--required ">Введите код подтверждения</label>
            <input class="phone-field__input error" id="UF_PHONECONFIRM_CODE" inputmode="numeric" size="30" type="text" name="UF_PHONECONFIRM_CODE" v-model="confirmCode" @keyup="phoneKeyUp">
            <a href="#" class="phone-field__send btn_red" v-if="!isPhoneConfirmed && isPhoneValid && smsWaiting && !checkConfirmPhone" @click.prevent="confirmCodeSend">Подтвердить</a>
            <span class="message error-text" v-if="showSmsCodeError">Неверный код</span>
          </div>
        </template>
        <template v-if="counter > 0 && !checkConfirmPhone" >
          <span class="message">Повторная отправка возможна через {{ counter }} сек.</span>
        </template>
<!--    </div>-->
  </template>
  <div class="phone-field">
    <input class="phone-field__input" inputmode="numeric" size="30" type="text" :name="name" :value="phone" :readonly="!!smsWaiting" :required="required" :pattern="pattern">

<!--    <a href="#" v-if="!isPhoneConfirmed && isPhoneValid && smsWaiting && !checkConfirmPhone" @click.prevent="confirmCodeSend()" class="phone-field__send">подтвердить</a>-->

    <template v-if="!captchaMessage" >
        <a href="#"  @click.prevent="send()" class="phone-field__send"
           v-if="!isPhoneConfirmed && isPhoneValid && !smsWaiting && !checkConfirmPhone"
           :class="{'disabled' : !isPhoneConfirmed && isPhoneValid && smsWaiting && !checkConfirmPhone && counter > 0}">Получить код</a>
    </template>
    <template v-if="!captchaMessage" >
      <template v-if="counter > 0" >
        <span class="message send_phone_code--phone-code-sended" v-if="!checkConfirmPhone">код отправлен</span>
      </template>
    </template>
    <span class="message" v-if="checkConfirmPhone">Код подтвержден</span>
    <span v-if="captchaMessage && !checkConfirmPhone" class="message error-text send_phone_code--phone-code-sended">{{captchaMessage}}</span>
    <span v-else class="message error-text"></span>
  </div>
  </div>
</template>
<script>
export default {
  name: 'PhoneConfirmRegistr',
  props : {
    name : {
      type : String,
      default : '',
    },
    pattern : {
      type : String,
      default : '',
    },
    value : {
      type : String,
      default : '',
    },
    required : {
      type : String,
      default : '',
    },
    phoneConfirmed : {
      type : String,
      default : "",
    },
  },
  data : () => ({
    phone : '',
    confirmCode : '',
    smsWaiting : false,
    smsSended : false,
    smsTimeout : null,
    smsInterval : null,
    ajaxProcessed : false,
    checkConfirmPhone: false,
    captchaMessage:false,//сообщение о безуспешной капче
    counter : 0,
    token:'',
    showSmsCodeError: false,
    siteKey:'6Le836sUAAAAAD9cJlwzn4nSqgI381giR_Q-Tf5P'
  }),
  mounted () {
    this.phone = this.value;
    setPhoneMask($('[name="'+this.name+'"]'));
    $('[name="'+this.name+'"]').keyup((e) => {
      this.phone = $(e.currentTarget).val();
    });
    if (+vxCommonStore.state.lastPhoneConfirmTimestamp > (moment().unix() - 60)) {
      this.waitingStart();
      this.counter = moment().unix() - +vxCommonStore.state.lastPhoneConfirmTimestamp;
    }
  },
  created:function(){
    var apps=this;
    grecaptcha.ready(function()
    {
      apps.refreshToken();
      setInterval(function()
      {
        apps.refreshToken();
      },20000)
    });
    if(this.phoneConfirmed){
      this.smsWaiting = true;
      this.checkConfirmPhone = true;
      vxCommonStore.state.isPhoneConfirmed = true;
      document.getElementById("btnRegistr").classList.add("active");
    }
  },
  computed : {
    confirmedPhones : () => vxCommonStore.state.confirmedPhones,
    isPhoneValid () {
      if (!this.phone) {
        return false;
      }
      var phone = this.phone.match(/\d+/ig).join('');
      return (phone.length == 11);
    },
    isPhoneConfirmed () {
      if (!this.phone) {
        return false;
      }
      var phone = this.phone.match(/\d+/ig).join('');
      return !!~vxCommonStore.state.confirmedPhones.indexOf(phone);
    },
  },
  watch : {
    counter (val, oldVal) {
      if (val <= 0) {
        this.waitingStop();
      }
    }
  },
  methods : {
    waitingStart () {
      this.smsSended = true;
      this.counter = 60;
      this.smsTimeout = setTimeout(
          () => {
            this.waitingStop();
          },
          1 * 60 * 1000
      );
      this.smsInterval = setInterval(
          () => {
            this.counter--;
          },
          1000
      );
    },
    refreshToken:function(){
      var apps = this;
      grecaptcha.execute(apps.siteKey,{action : "homepage"}).then(
          function( token )
          {
            apps.token=token;
          });
    },
    waitingStop () {
      this.ajaxProcessed = false;
      this.smsWaiting = false;
      this.counter = 0;
      clearInterval(this.smsInterval);
      clearTimeout(this.smsTimeout);
    },
    confirmCodeSend(){
      XPage.ajax({
        data : {
          'ajax_command' : 'check_confirm_phone',
          'phone' : this.phone,
          'confirmCode' : this.confirmCode,
          'captchaToken':this.token//токен капчи
        },
        success : (response) => {
          if (response.success) {
            this.checkConfirmPhone = true;
            this.showSmsCodeError = false;
            vxCommonStore.state.isPhoneConfirmed = true;
            document.getElementById("btnRegistr").classList.add("active");
          }
          else
            {
              this.showSmsCodeError = true;
              if(response.error){
                showHeaderMessage(response.error, 'error');
                this.captchaMessage='';
              }else{
                this.captchaMessage='';
                showHeaderMessage("Проверка не пройдена. Попробуйте ввести другой код.", 'error');
              }
              this.checkConfirmPhone = false;
              document.getElementById("btnRegistr").classList.remove("active");
              vxCommonStore.state.isPhoneConfirmed = false;
            }
        }
      });
    },
    send () {
      if (this.ajaxProcessed || this.smsWaiting) {
        return;
      }
      this.ajaxProcessed = true;
      this.smsWaiting = true;
      XPage.ajax({
        data : {
          'ajax_command' : 'confirm_phone',
          'request_type':'phoneConfirmRegister',
          'phone' : this.phone,
          'captchaToken':this.token//токен капчи
        },
        success : (response) => {
          if (response.success && response.captchaResult) {
            vxCommonStore.commit('setLastPhoneConfirmTimestamp', moment().unix());
            this.waitingStart();
          }
          else if(!response.captchaResult)
            {
              this.captchaMessage='Проверка не пройдена. Попробуйте перезагрузить страницу или зайти с другого браузера.'
            }else if(response.error){
            showHeaderMessage(response.error, 'error');
          }
        }
      });
    },
    phoneKeyUp(){
      this.confirmCode = this.confirmCode.replace(/\D+/g,"");
    }
  },
}
</script>


